import React from 'react';
import { Card } from '@/components/ui/card';

const HomeFAQ = () => {
  const faqs = [
    {
      question: "What will I learn about myself?",
      answer: "You'll discover your behavioral profile across 5 key dimensions: Drive, Connection, Task, Order, and Style. Plus, you'll understand your natural work style, strengths, and how you interact with others."
    },
    {
      question: "How long does the assessment take?",
      answer: "The behavioral assessment takes about 10-15 minutes. If you add the optional cognitive assessment, it takes an additional 20 minutes. You can save your progress and come back anytime."
    },
    {
      question: "Is it free?",
      answer: "Yes! The behavioral assessment is completely free for individuals. You'll get your full results immediately with detailed insights about your personality and work style."
    },
    {
      question: "Is my data private?",
      answer: "Absolutely. Your assessment data is encrypted and stored securely. We never share your personal information or results with third parties. You control who sees your results."
    },
    {
      question: "What's the science behind this?",
      answer: "Our assessment is based on the Five-Factor Model (OCEAN framework), adapted for business contexts. We use z-score methodology and percentile rankings for statistical accuracy. Learn more on our Science page."
    },
    {
      question: "Can I share my results?",
      answer: "Yes! After completing your assessment, you can download your results as a PDF and share them however you'd like. You'll get a comprehensive report with charts and insights."
    }
  ];

  return (
    <section className="py-24 px-6 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Frequently Asked Questions
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            Everything you need to know about your personality assessment
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {faqs.map((faq, index) => (
            <Card key={index} className="p-8 border border-gray-200 bg-white">
              <h4 className="text-xl font-bold text-gray-900 mb-4 tracking-tight">
                {faq.question}
              </h4>
              <p className="text-gray-600 font-medium leading-relaxed">
                {faq.answer}
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeFAQ;
